import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';// import { useSelector } from 'react-redux';
// import { RootState } from 'app/store/rootReducer';
// import { fetchReplies } from 'features/posts/repliesSlice';
import { getTimeAgo, getTimeToExpiration, renderHTMLSafe } from 'services/posts-service'; 
import renderer, { replaceIPFSVideoLinks } from 'helpers/contentRenderer';  
import ReplyEditorToggle from './ReplyEditorToggle';
import VoteButton from './VoteButton'; 
import ContentEditPostModal from 'features/content/contentModals/ContentEditPostModal';
import { useAuth } from 'helpers/authContext';
import { get_ipfs_usage } from 'services/db-service';
import RewardsButton from './RewardsButton';
import { getReputation } from 'services/dsteem-service';
import { VerifiedIcon } from './VerifiedIcon';
import ShellIcon from './ShellIcon';
type Props = {
  post: any; 
  onError: (msg: string) => void;
  onLogin: Function; 
  userPlans:any; 
  setLocalReplies:Function; 
  localReplies:any;
  isLoadingReplies?:any;  
};

const VideoReplies = ({ post, onError, onLogin, userPlans,
    localReplies, setLocalReplies, 
    isLoadingReplies = false
    }: Props) => { 
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [replyToEdit, setReplyToEdit] = useState(null);
    const [ipfsAccount, setIpfsAccount] = useState<any>({});
    const { user } = useAuth();
    useEffect(() => {
        (async () => {
            const ipfs = await get_ipfs_usage(`@${user}:speem`); 
            setIpfsAccount(ipfs || []);
        })()
    }, []); 
    const handleNewReply = (newReply) => {
      console.log("Adding reply",newReply); 
      setLocalReplies((prev) => {
        if (newReply.parent_author == post.author && newReply.parent_permlink == post.permlink) {
          return [...prev, newReply];
        } 

        const newArray = [];
        let inserted = false;

        for (const e of prev) {
          newArray.push(e);

          if (
            !inserted &&
            newReply.parent_author === e.author &&
            newReply.parent_permlink === e.permlink
          ) {
            newArray.push(newReply);
            inserted = true; 
          }
        } 
        if (!inserted) {
          newArray.push(newReply);
        }
        return newArray; 
      });
    }; 
    const renderReply = (reply, index) => {
        const depth = reply.depth - post.depth;
        let payoutTimeString = getTimeToExpiration(reply.created); 
        let reputation = (typeof post.author_reputation  == "string") ? `(${getReputation(reply.author_reputation)})`:`(${reply.author_reputation.toFixed(0)||0})`;
        const plan = userPlans.find(u => u.username === reply.author);  
        let isPlus = plan?.plan_type?.includes("plus") || false;
        return (
        <div key={reply.id} className={`reply-container mt-3 depth-${depth}`}>
            <div className="reply-header">
              <Link to={`/u/${reply.author}`} className="reply-avatar">
                <img src={`https://steemitimages.com/u/${reply.author}/avatar`} alt={reply.author} width={34} height={34} />
              </Link>
              <div className="reply-meta">
                <div className="reply-author-line">
                  <Link to={`/u/${reply.author}`} className={reply.root_author === reply.author ? 'reply-author-name' : ''}>@{reply.author} <span className="reply-reputation">{reputation}</span></Link>
                  {isPlus && <span title="Verified Plus member"><VerifiedIcon size={16} className="color-speem" /></span>}
                </div>
                <Link to={'/p/'+reply.author+'/'+reply.permlink} className="reply-created">{getTimeAgo(reply.created)}</Link>
              </div>
            </div>
            <div className="reply-body body-content mt-2">
            {renderHTMLSafe(replaceIPFSVideoLinks(renderer.render(reply.body)))}
            </div>
            <div className="reply-actions mt-2" data-id={index}>  
                <VoteButton 
                className='post-tools'
                position='left'
                post={reply} 
                onLogin={() => onError("You must log in to vote or reply")} 
                author={reply.author} 
                permlink={reply.permlink} 
                reward_fund={post.reward_fund} 
                median_price={post.median_price} 
                setLocalReplies={setLocalReplies} 
                onNewError={onError}
                />
                <RewardsButton 
                  payoutTimeString={payoutTimeString}
                  post={reply}
                  onNewError={() => console.log("error")}
                  position='left'
                  className='post-tools'
                />
                {reply.author == user && (
                  <button
                    className="btn post-tools"
                    onClick={() => {
                      setReplyToEdit(reply);
                      setIsEditOpen(true);
                    }}
                  >
                    <i className="fas fa-pen" /> Edit
                  </button> 
                )}
                <ReplyEditorToggle
                  depth={1}
                  author={reply.author}
                  permlink={reply.permlink}
                  parent_author={post.author}
                  IpfsAccount={ipfsAccount}
                  parent_permlink={post.permlink}
                  onLogin={onLogin}
                  onNewError={onError}
                  onSuccess={handleNewReply}
                />
            </div> 
            

        </div>
        );
    };

    // if (isLoadingReplies) {
    //     return <div className="text-center mt-3"><span className="spinner dark" /></div>;
    // }

    return ( 
        <div className="video-replies">   
            <div className="replies">
                {isLoadingReplies ? <div className="comments-loading" role="status"><span className="spinner small m-0" /><span>Loading comments...</span></div>
                  : localReplies?.length > 0 ? localReplies.map((r, idx) => renderReply(r, idx))
                  : <div className="comments-empty"><ShellIcon name="comment" size={32} /><strong>No comments yet</strong><p>Start the conversation.</p></div>}
            </div>

            {replyToEdit && (
              <ContentEditPostModal
                isShowing={isEditOpen}
                hide={() => setIsEditOpen(false)}
                isComment={true}
                title={replyToEdit.title || ""}
                description={replyToEdit.body}
                tags={""} 
                post={replyToEdit}
                onSuccess={(updatedReply) => {
                  setLocalReplies(prev =>
                    prev.map(r => r.permlink === updatedReply.permlink ? updatedReply : r)
                  );
                  setIsEditOpen(false);
                }}
              />
            )}

        </div> 
    );
};

export default VideoReplies; 